export async function createWorkerBlobUrl(workerUrl: string) {
	const res = await fetch(workerUrl)
	const body = new Response(res.body)
	const blob = await body.blob()
	return URL.createObjectURL(blob)
}
